<template>
  <v-dialog v-model="visible" max-width="400">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      
      <v-card-text>
        {{ message }}
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="cancel">
          Cancelar
        </v-btn>
        <v-btn color="primary" text @click="confirm">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      visible: false,
      title: '',
      message: '',
      resolvePromise: null
    }
  },
  methods: {
    show(dialogTitle, dialogMessage) {
      this.title = dialogTitle
      this.message = dialogMessage
      this.visible = true
      
      return new Promise((resolve) => {
        this.resolvePromise = resolve
      })
    },
    confirm() {
      this.visible = false
      if (this.resolvePromise) this.resolvePromise(true)
    },
    cancel() {
      this.visible = false
      if (this.resolvePromise) this.resolvePromise(false)
    }
  }
}
</script>